<template>
  <div>
    <b-table-simple hover small responsive striped>
      <b-thead class="t-head hh-t-head">
        <b-tr>
          <b-th class="text-center">
            Orasul de transfer
          </b-th>
          <b-th class="text-center">
            Locul de imbarcare
          </b-th>
          <b-th class="text-center">
            Tarif / pers / tur-retur
          </b-th>
          <b-th class="text-center">
            Tarif Premium/ pers / sens
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody class="text-center">
        <b-tr>
          <b-td>ROMAN</b-td>
          <b-td>Hotel Roman</b-td>
          <b-td>
            <div class="transfer-price">65 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">220 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>PIATRA NEAMT</b-td>
          <b-td>Lidl 1 Mai</b-td>
          <b-td>
            <div class="transfer-price">65 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">230 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>BACAU</b-td>
          <b-td>Parcarea Stadionului Municipal</b-td>
          <b-td>
            <div class="transfer-price">60 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">190 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>ADJUD</b-td>
          <b-td>Restaurant Atlantic</b-td>
          <b-td>
            <div class="transfer-price">55 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">150 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>FOCSANI</b-td>
          <b-td>Lidl – Fosta Autogara</b-td>
          <b-td>
            <div class="transfer-price">50 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">130 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>RAMNICU SARAT</b-td>
          <b-td>Restaurant Turist (Profi)</b-td>
          <b-td>
            <div class="transfer-price">45 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">100 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>BUZAU</b-td>
          <b-td>Patinoar Restaurant Diana</b-td>
          <b-td>
            <div class="transfer-price">45 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">80 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>IASI</b-td>
          <b-td>Parcare Lidl – vis-a-vis de Iulius Mall</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">250 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>VASLUI</b-td>
          <b-td>Benzinaria OMV (Str.Stefan cel Mare)</b-td>
          <b-td>
            <div class="transfer-price">65 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">210 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>BARLAD</b-td>
          <b-td>Statie Renel</b-td>
          <b-td>
            <div class="transfer-price">65 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">180 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>GALATI</b-td>
          <b-td>Parcare Sala Sporturilor</b-td>
          <b-td>
            <div class="transfer-price">50 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">160 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>BRAILA</b-td>
          <b-td>Panda (Calarasi) – Bariera)</b-td>
          <b-td>
            <div class="transfer-price">50 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">140 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SLOBOZIA</b-td>
          <b-td>Benzinaria Rompetrol (Sos.Bucuresti-Constanta)</b-td>
          <b-td>
            <div class="transfer-price">60 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">90 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>TULCEA</b-td>
          <b-td>Parcare Complex Pelican</b-td>
          <b-td>
            <div class="transfer-price">80 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">180 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>CONSTANTA</b-td>
          <b-td>Gara CFR</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">140 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>MEDGIDIA</b-td>
          <b-td>Restaurant Balada</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">130 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>TARGOVISTE</b-td>
          <b-td>Hotel Valahia</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">100 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>TARGU MURES*</b-td>
          <b-td>Parcare Kaufland – Bd.Gheorghe Doja</b-td>
          <b-td>
            <div class="transfer-price">100 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">220 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>MEDIAS*</b-td>
          <b-td>Autogara</b-td>
          <b-td>
            <div class="transfer-price">100 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">210 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SIGHISOARA*</b-td>
          <b-td>Benzinaria Rompetrol</b-td>
          <b-td>
            <div class="transfer-price">90 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">190 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>FAGARAS</b-td>
          <b-td>Casa de Cultura</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">170 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SFANTU GHEORGHE</b-td>
          <b-td>Benzinaria Rompetrol</b-td>
          <b-td>
            <div class="transfer-price">70 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">170 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>MIERCUREA CIUC*</b-td>
          <b-td>Benzinaria MOL – Str. Brasovului</b-td>
          <b-td>
            <div class="transfer-price">90 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">200 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>BRASOV</b-td>
          <b-td>Benzinaria Mol - Calea Bucuresti</b-td>
          <b-td>
            <div class="transfer-price">55 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">120 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SINAIA</b-td>
          <b-td>Gara</b-td>
          <b-td>
            <div class="transfer-price">50 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">100 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>CAMPINA</b-td>
          <b-td>Benzinaria OMV – Nicolae Balcescu 60</b-td>
          <b-td>
            <div class="transfer-price">45 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">80 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>PLOIESTI</b-td>
          <b-td>Benzinaria Petrom Metro</b-td>
          <b-td>
            <div class="transfer-price">40 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">70 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>DEVA*</b-td>
          <b-td>McDonald’s Gara</b-td>
          <b-td>
            <div class="transfer-price">100 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">250 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>ORASTIE*</b-td>
          <b-td>Benzinaria Rompetrol (Str.Unirii)</b-td>
          <b-td>
            <div class="transfer-price">100 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">230 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>ALBA IULIA*</b-td>
          <b-td>Gara</b-td>
          <b-td>
            <div class="transfer-price">100 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">230 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SEBES*</b-td>
          <b-td>Rompetrol, iesire Lancram</b-td>
          <b-td>
            <div class="transfer-price">95 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">220 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SIBIU</b-td>
          <b-td>Benzinaria Mol - Selimbar</b-td>
          <b-td>
            <div class="transfer-price">80 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">180 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>RAMNICU VALCEA</b-td>
          <b-td>Sala Sporturilor</b-td>
          <b-td>
            <div class="transfer-price">60 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">120 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>PITESTI</b-td>
          <b-td>Petrom Podul Viilor</b-td>
          <b-td>
            <div class="transfer-price">50 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">90 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>SLATINA</b-td>
          <b-td>Benzinaria OMV</b-td>
          <b-td>
            <div class="transfer-price">60 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">120 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>CRAIOVA</b-td>
          <b-td>Benzinaria Petrom Gara</b-td>
          <b-td>
            <div class="transfer-price">65 &euro;</div>
          </b-td>
          <b-td>
            <div class="text-purple">150 &euro;</div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td colspan="4" class="text-left">
            <small>
              Pentru orasele marcate cu ‘’ * ‘’, conditia pentru efectuarea transferului este de minim 2 persoane. Daca nu
              se intrunesc un numar minim de 2 persoane
              pana la 14 zile inaintea plecarii, turistului i se va restitui contravaloarea transferului sau are optiunea
              de a plati un supliment in valoare de 80% din pretul
              transferului pentru a beneficia de acesta.
            </small>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <h5 class="text-primary border-bottom">TRANSFERURI DIN TARA SI CONDITII GENERALE TRANSPORT</h5>
    <p><strong>Prezentul program este parte integranta a contractului de prestari servicii</strong></p>
    <ul>
      <li>
        <p class="mb-0"><strong>Conditii specifice</strong></p>
        <h6 class="text-purple">TRANSFERURI DE GRUP</h6>
      </li>
      <li>Transferurile de grup se confirma automat/garantat in momentul
        inscrierii, indiferent de numarul de participanti, pentru rezervarile efectuate
        cu mai mult de 14 zile inaintea plecarii. Pentru orice solicitare ulterioara,
        transferul se confirma doar in limita disponibilitatii. Pentru rezervarile
        efectuate cu mai putin de 14 zile inaintea plecarii, orice solicitare de
        transfer se confirma in limita disponibilitatii. Transferurile de grup se pot
        rezerva doar in regim dus-intors. Transferurile se pot efectua cu
        autoturism, microbuz, minibus, autocar sau prin operatori de linie;
      </li>
      <li>
        Locurile de imbarcare sunt informative; pot fi diferite in functie de
        partenerul care efectueaza transferul si se reconfirma o data cu informarea
        de plecare, cu 3 zile sau, prin exceptie, cu maximum 24 de ore inainte de
        plecare. Traseele pot suferi modificari in functie de nr. participantilor, pot
        implica mai multe mijloace de transport (3-4 schimbari) si pot exista timpi
        de asteptare intre imbarcare/debarcare si preluarea/-ile de catre partener/-
        ii care efectueaza transferul.
      </li>
      <li>
        Ora de imbarcare si numarul de telefon ale soferului si/sau de
        dispecerat se vor comunica cu 3 zile (prin exceptie 24 de ore) inaintea
        datei plecarii. Calatorul va tine legatura cu transportatorul pentru a se
        informa privind situatia concreta din ziua plecarii. Pentru transferul de
        retur, detaliile sunt oferite de personalul de la bordul autocarului in timpul
        calatoriei de intoarcere. Turistii sunt rugati sa se prezinte la locul de
        imbarcare cu 15-30 min. inainte de ora comunicata - grupul nu poate
        astepta turistii care intarzie.
      </li>
      <li>
        Pentru orasele marcate cu ‘’ * ‘’, conditia pentru efectuarea transferului
        este de minim 2 persoane. Daca nu se intrunesc un numar minim de 2
        persoane pana la 14 zile inaintea plecarii, turistului i se va restitui
        contravaloarea transferului sau are optiunea de a plati un supliment in
        valoare de 80% din pretul transferului pentru a beneficia de acesta.
      </li>
      <li>
        Toate rezervarile trebuie insotite in mod obligatoriu de numarul de
        telefon al pasagerilor, disponibil la momentul plecarii, cu roaming activat
        obligatoriu. Agentiile partenere au obligatia de a transmite numarul de
        telefon al turistilor inscrisi, catre Hello Holidays.
      </li>
      <li>
        Numarul de contact al turistilor este foarte important pentru ca, mai
        ales in cazul transferurilor - cand pot aparea diferite modificari, intarzieri
        s.a., acestia vor fi contactati de catre sofer/dispecerat. Agentia Hello
        Holidays nu este raspunzatoare de imposibilitatea contactarii pasagerilor
        din cauza netransmiterii informatiilor obligatorii solicitate sau transmiterea
        incorecta a acestora si nu va restitui contravaloarea tranferului sau a
        pachetului de servicii.
      </li>
    </ul>
    <ul>
      <li>
        <p class="mb-0"><strong>Conditii specifice</strong></p>
        <h6 class="text-success"><strong>TRANSFERURI PREMIUM</strong></h6>
      </li>
      <li><strong>*Tarifele sunt de persoana, pe sens.</strong></li>
      <li>Transferurile Premium se confirma la cerere, in limita disponibilitatii,
        cu pana la 7 zile inainite de plecare, se efectueaza cu microbuz/autoturism
        si se organizeaza pentru min. 2 persoane, max. 7 persoane/masina.</li>
      <li>Preluarea si debarcarea se fac de la si la adresa indicata de catre
        turisti, fara a exista timpi suplimentari de asteptare (exceptie fac cazurile
        de forta majora) si implica un singur mijloc de transport.</li>
      <li>Debarcarea la punctul de plecare a grupului din Bucuresti se face cu
        max. 30-45 minute inainte de ora de intalnire stabilita conform informarii
        primite de la agentie.</li>
      <li>
        La retur timpul de preluare din punctul de debarcare este de max. 30-45 minute.
      </li>
    </ul>
    <ul>
      <li>
        <h6 class="text-danger"><strong>Conditii generale transport rutier</strong></h6>
      </li>
      <li>In mijloacele de transport sunt strict interzise: fumatul, consumul de
        bauturi alcoolice, consumul de droguri si substante stupefiante. Ne
        rezervam dreptul de a debarca pasagerii in stare de ebrietate si pasagerii
        care afecteaza ordinea si siguranta celorlalti pasageri sau a conducatorilor
        auto, ori incalca prezentele conditii, fara rambursarea costurilor de
        transport.
      </li>
      <li>Pasagerii se obliga sa achite catre societatea de transport
        contravaloarea oricaror distrugeri aduse mijloacelor de transport.</li>
      <li>Transportul animalelor se supune unui regim special. Turistii
        apartinatori au obligatia de a solicita aprobarea agentiei.</li>
      <li>Cazul fortuit si forta majora exonereaza societatea de transport de
        orice raspundere.</li>
      <li>
        Bagaje admise pentru fiecare pasager ocupant de loc: la cala 1 piesa
        de bagaj de max. 23 kg/pasager; in autocar se accepta max. 1 rucsac
        (geanta mica de mana – piesele mai mari vor fi depozitate la cala). In cazul
        nerespectarii regulilor, personalul de la bord are dreptul de a debarca
        pasagerii.
      </li>
    </ul>
    <hr>
    <div class="text-center">
      <h5 class="text-dark">Prezentul program este parte integranta a contractului de prestari servicii.</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsRomania'
}
</script>

<style lang="scss" scoped>
.transfer-price {
  font-weight: 900;
  font-size: 1rem;
  color: rgb(255, 111, 0);
}

.text-purple {
  color: rebeccapurple;
  font-weight: 900;
  font-size: 1rem;
}
</style>
